import styled from 'styled-components';

const SettingsItemBody = styled.div`
  margin: 2rem auto;
  width: 32rem;
`;

export default SettingsItemBody;
